export interface BaseInvestmentSheet {
  id?: string;
  investorId: string;
  productId: string;
  phaseId: string;
  importe: number;
  origenFondos?: string;
  titularCuentaDevolucion?: string;
  ibanDevolucion?: string;
  porcentajeIntFase?: number;
  porcentajeIntFidelizacion?: number;

  // Fechas (opcionales, formato YYYY-MM-DD)
  solicitaContrato?: string;
  fechaContrato?: string;
  fechaFirmaCliente?: string;
  fechaFirmaClub?: string;
  fechaTransRecibida?: string;
  fechaDevCapital?: string;
  fechaLiquidacion?: string;
  fechaRechazado?: string;

  // Documentos
  contratoPdf?: string;
  transferenciaPdf?: string;

  // Estados
  estadoKyc?: string;
  estado?: string;

  // Auditoria
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
  sheetType?: 'CRV' | 'PH' | 'CRA';
}

export interface InvestmentSheetCrv extends BaseInvestmentSheet {
  // Interés y Rendimiento
  intFidelizacion?: number;
  interesesDevengados?: number;
  totalIntDevengados?: number;
  interesesAnticipados?: number;
  liqFinalPendiente?: number;
  rtoAnualInicial?: number;
  rtoAnualActual?: number;
}

export interface InvestmentSheetPh extends BaseInvestmentSheet {
  // Interés y Rendimiento
  intFidelizacion?: number;
  interesesAcumulados?: number;
  totalALiquidar?: number;
  interesesPagados?: number;
  capitalDevuelto?: number;
  liqFinalPendiente?: number;
  rtoAnualInicial?: number;
  rtoAnualActual?: number;
}

export interface InvestmentSheetCra extends BaseInvestmentSheet {
  // Tickets y Valoración
  numTickets?: number;
  capitalDevuelto?: number;
  valorNominalInversion?: number;
  valorActualInversion?: number;
  plusvaliaLatente?: number;
  porcentajeRevalTotal?: number;
  repartosCobrados?: number;
  liqFinalPendiente?: number;
  rtoAnualActual?: number;
}

export type InvestmentSheet = InvestmentSheetCrv | InvestmentSheetPh | InvestmentSheetCra;

export type SheetType = 'crv' | 'ph' | 'cra';

export const SHEET_TYPE_LABELS: Record<SheetType, string> = {
  crv: 'CRV - Total con Anticipos',
  ph: 'PH - Renta Fija',
  cra: 'CRA - Participativo',
};

export const ESTADO_KYC_OPTIONS = [
  { value: 'Pendiente', label: 'Pendiente' },
  { value: 'Validado', label: 'Validado' },
];

export const ESTADO_FICHA_OPTIONS = [
  { value: 'Prospecto', label: 'Prospecto' },
  { value: 'Pdte. contrato', label: 'Pdte. contrato' },
  { value: 'Pdte. firma', label: 'Pdte. firma' },
  { value: 'Pdte. transferencia', label: 'Pdte. transferencia' },
  { value: 'Activo', label: 'Activo' },
  { value: 'Devuelto principal', label: 'Devuelto principal' },
  { value: 'Liquidado', label: 'Liquidado' },
  { value: 'Rechazado', label: 'Rechazado' },
];
